import React from 'react'
import { Button, Modal, Select } from 'antd'
import { upperFirst } from 'lodash'

import { manageToast } from '../../components/Common/ManageToast'

import { serverlessApi } from '../../utils/API'


function StatusCell (props) {
  const {
    disabled,
    name,
    onSuccess,
    _id,
    refetch,
    status,
    typeName,
    requestKey,
    statusOptions
  } = props

  const [nextStatus, setNextStatus] = React.useState(status)
  const [loading, setLoading] = React.useState(false)
  const [open, setOpen] = React.useState(false)

  if (!status) {
    return '--'
  }

  const handleClose = () => setOpen(false)

  const handleValueChange = value => {
    setNextStatus(value)
    setOpen(true)
  }

  const handleStatusChange = () => {
    setLoading(true)

    serverlessApi[requestKey](_id, {
      status: nextStatus
    }).then(() => {
      setLoading(false)
      setOpen(false)
      onSuccess && onSuccess()
      refetch()
      manageToast(true, `${upperFirst(typeName)} "${name}" updated successfully`)
    }).catch(() => {
      manageToast(false, `Error updating ${typeName} status`)
      setLoading(false)
      setOpen(false)
    })
  }

  return (
    <>
      <Select
        onChange={handleValueChange}
        placeholder="Select status"
        options={statusOptions}
        className="w-[140px]"
        disabled={disabled}
        loading={loading}
        value={status}
      />

      <Modal
        title={`Confirm ${typeName} status change`}
        open={open}
        onCancel={handleClose}
        footer={null}
      >
        Are you sure you want to change status of {typeName} "{name}"
        from "{status}" to "{nextStatus}"?

        <div className="flex gap-3 justify-end items-end pt-5">
          <Button
            className="hover:!text-buttonTheme hover:!border-buttonTheme"
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            loading={loading}
            onClick={handleStatusChange}
            className="bg-buttonTheme hover:!bg-buttonHoverTheme self-end"
            type='primary'
          >
            Change status
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default StatusCell
